var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100pt",
    height: "101pt",
    viewBox: "0 0 100 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 0.597656 0.429688 L 99.402344 0.429688 L 99.402344 11.828125 L 0.597656 11.828125 L 0.597656 0.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5.0003,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.61313
    },
    d: "M 5.976563 1005.703125 L 994.023438 1005.703125 L 994.023438 891.71875 L 5.976563 891.71875 Z M 5.976563 1005.703125 ",
    transform: "matrix(0.1,0,0,-0.1,0,101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 0.597656 30.828125 L 99.402344 30.828125 L 99.402344 42.230469 L 0.597656 42.230469 L 0.597656 30.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5.0003,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.61313
    },
    d: "M 5.976563 701.71875 L 994.023438 701.71875 L 994.023438 587.695313 L 5.976563 587.695313 Z M 5.976563 701.71875 ",
    transform: "matrix(0.1,0,0,-0.1,0,101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 0.597656 61.230469 L 99.402344 61.230469 L 99.402344 72.632813 L 0.597656 72.632813 L 0.597656 61.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5.0003,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 2.61313
    },
    d: "M 5.976563 397.695313 L 994.023438 397.695313 L 994.023438 283.671875 L 5.976563 283.671875 Z M 5.976563 397.695313 ",
    transform: "matrix(0.1,0,0,-0.1,0,101)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 13.8125 81.371094 L 17.414063 81.371094 L 22.753906 97.066406 L 28.042969 81.371094 L 31.605469 81.371094 L 31.605469 99.9375 L 29.222656 99.9375 L 29.222656 88.980469 C 29.222656 88.601563 29.230469 87.96875 29.246094 87.09375 C 29.261719 86.21875 29.269531 85.28125 29.269531 84.277344 L 23.976563 99.9375 L 21.488281 99.9375 L 16.152344 84.277344 L 16.152344 84.847656 C 16.152344 85.300781 16.164063 85.996094 16.1875 86.925781 C 16.207031 87.859375 16.214844 88.542969 16.214844 88.980469 L 16.214844 99.9375 L 13.8125 99.9375 Z M 35.679688 81.371094 L 49.210938 81.371094 L 49.210938 83.648438 L 38.128906 83.648438 L 38.128906 89.28125 L 48.378906 89.28125 L 48.378906 91.429688 L 38.128906 91.429688 L 38.128906 97.722656 L 49.398438 97.722656 L 49.398438 99.9375 L 35.679688 99.9375 Z M 52.695313 81.371094 L 55.667969 81.371094 L 65.039063 96.414063 L 65.039063 81.371094 L 67.429688 81.371094 L 67.429688 99.9375 L 64.613281 99.9375 L 55.097656 84.914063 L 55.097656 99.9375 L 52.695313 99.9375 Z M 74.117188 81.371094 L 74.117188 92.84375 C 74.117188 94.195313 74.371094 95.316406 74.875 96.210938 C 75.621094 97.554688 76.886719 98.226563 78.667969 98.226563 C 80.796875 98.226563 82.246094 97.5 83.011719 96.046875 C 83.425781 95.25 83.632813 94.1875 83.632813 92.84375 L 83.632813 81.371094 L 86.183594 81.371094 L 86.183594 91.796875 C 86.183594 94.078125 85.878906 95.839844 85.261719 97.066406 C 84.132813 99.304688 82 100.429688 78.867188 100.429688 C 75.734375 100.429688 73.605469 99.304688 72.484375 97.066406 C 71.867188 95.839844 71.5625 94.078125 71.5625 91.796875 L 71.5625 81.371094 L 74.117188 81.371094 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e31c241f3d0d6ccea7b8059a2a1b6d88.svg";
export { ForwardRef as ReactComponent };